import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SimpleBanner } from './SimpleBanner';
import { removeBanner, selectBannerToDisplay } from './Banners.reducer';
var banners = {
  GenericAnnouncement: function GenericAnnouncement(props) {
    return React.createElement(SimpleBanner, props);
  },
  GenericNotification: function GenericNotification(props) {
    return React.createElement(SimpleBanner, props);
  },
  SuccessNotification: function SuccessNotification(props) {
    return React.createElement(SimpleBanner, _extends({}, props, {
      type: "success"
    }));
  },
  FailureNotification: function FailureNotification(props) {
    return React.createElement(SimpleBanner, _extends({}, props, {
      type: "failure"
    }));
  }
};
export var registerBanner = function registerBanner(componentName, component) {
  return banners[componentName] = component;
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    activeBanner: selectBannerToDisplay(props.category, state)
  };
};

var mapDispatchToProps = {
  onBannerClose: removeBanner
};
export var BannerHostUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(BannerHostUnwrapped, _Component);

  function BannerHostUnwrapped() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, BannerHostUnwrapped);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BannerHostUnwrapped)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleBannerClose", function () {
      var _this$props = _this.props,
          id = _this$props.activeBanner.id,
          onBannerClose = _this$props.onBannerClose;
      onBannerClose(id);
    });

    return _this;
  }

  _createClass(BannerHostUnwrapped, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          category = _this$props2.category,
          activeBanner = _this$props2.activeBanner,
          className = _this$props2.className;

      if (!activeBanner) {
        return null;
      }

      var bannerProps = activeBanner.props,
          bannerType = activeBanner.component;
      var BannerComponent = banners[bannerType];

      if (!BannerComponent) {
        throw new Error("Unknown banner type '".concat(bannerType, "'"));
      }

      return React.createElement("div", {
        className: "banner-host banner-host--".concat(category, " ").concat(className || '')
      }, React.createElement(BannerComponent, _extends({}, bannerProps, {
        onClose: this.handleBannerClose
      })));
    }
  }]);

  return BannerHostUnwrapped;
}(Component);
BannerHostUnwrapped.propTypes = {
  className: PropTypes.string,
  category: PropTypes.oneOf(['notification', 'announcement']).isRequired,
  onBannerClose: PropTypes.func.isRequired,
  activeBanner: PropTypes.shape({
    id: PropTypes.string.isRequired
  })
};
export var BannerHost = connect(mapStateToProps, mapDispatchToProps)(BannerHostUnwrapped);